export function digitalPurchasePath(orderID: string, owner: 'account' | 'organization') {
  return `/digital-resources?${new URLSearchParams({ tab: 'purchases', purchase_q: orderID, owner })}`;
}

export function digitalProjectAssetPath(projectID: string, orderID: string) {
  return `/projects/${encodeURIComponent(projectID)}?${new URLSearchParams({ tab: 'files', license_order: orderID })}`;
}
